<template>
  <div class="dropdown">
      <div class="dropdown-bar">
        <div class="selected" @click="toggle">
        <span class="dropdown-text">
          {{selection}}
        </span>
        </div>
        <div class="arrow" @click="toggle">
          <div class="published-icon">
            <Fai :icon="['fas', 'chevron-down']"/>
          </div>
        </div>
      </div>
      <div class="options" v-show="isOpen">
        <div class="scrollable" @click="toggle">
          <slot></slot>
        </div>
        <div class="backdrop" @click="toggle"></div>
      </div>
  </div>
</template>

<script>
  export default {
    name: 'Dropdown',
    props: ['selection'],

    data() {
      return {
        isOpen: false,
      }
    },

    methods: {
      toggle() {
        this.isOpen = !this.isOpen;
      },
    },
  }
</script>

<style scoped lang="scss">

  @import "../../scss/main";

  .published-icon {
    color: white;
    text-align: center;
    height: 40px;
    line-height: 40px;
    @media #{$mobile} {
      height: 20px;
      line-height: 20px;
    }
    vertical-align: middle
  }

  .dropdown{
    position: relative;
    display: inline-block;
    width: 100%;
    cursor: pointer;
  }

  .dropdown-bar {

  }

  .dropdown-text{
    display: inline-block;
    vertical-align: middle;
    line-height: normal;
    padding: 0 10px;
  }

  .selected {
    display: inline-block;
    width: calc(100% - 40px);
    height: 40px;
    line-height: 40px;
    @media #{$mobile} {
      width: calc(100% - 20px);
      height: 20px;
      line-height: 20px;
    }
    background: $gray-1;
    color: #000000;
  }

  .backdrop {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: -1;
  }

  .arrow {
    display: inline-block;
    width: 40px;
    height: 40px;
    @media #{$mobile} {
      width: 20px;
      height: 20px;
    }
    background: #f46446;
  }

  .options {
    position: absolute;
    display: block;
    z-index: 1;
    left: 0;
    top: 100%;
    width: 100%;
    margin-top: 3px;
    background: #fff;
    border-color: #111111;
    border-bottom: 1px solid rgba(0, 0, 0, 0.25);

    .scrollable{
      max-height: 20em;
      overflow: auto;
    }
  }
</style>
